import { render, staticRenderFns } from "./PanoWrapper.vue?vue&type=template&id=b1c80080&scoped=true"
import script from "./PanoWrapper.vue?vue&type=script&lang=ts"
export * from "./PanoWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PanoWrapper.vue?vue&type=style&index=0&id=b1c80080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c80080",
  null
  
)

export default component.exports